import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { getAmcList } from '../../redux-store/actions/nct';
import { getMasterData, getMasterFunds } from '../../redux-store/actions/newPurchase';
import { HOME_PATH } from '../../utils/constants';
import RouteWrapper from '../dashboard/routes';
import { InactiveFolioPaths } from './InactiveFolios/types';
import { QuickLinks } from './routerConfig';
import { getPageHeading } from '../../lib/pageHeading';

function QuickLinkRoutes(props: any) {
    const { pathname = '' } = props.location;

    const findPath = (pathname: string) => {
        return pathname.includes('/links') ? true : false;
    };
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        async function init() {
            try {
                await dispatch(getAmcList());
                await dispatch(getMasterData());
                dispatch(getMasterFunds());
            } catch (err: any) {
                alert(err.message);
            }
        }
        init();
    }, []);
    const { path } = props.match;
    return (
        <div className="container-fluid db-layout quick-links-layout">
            <header>
                <div className="maxWidth">
                    <a className="header-logo" onClick={() => props.history.push(HOME_PATH)}>
                        <img src="/images/logo.svg" alt="MF Central logo" />
                    </a>
                    {pathname === `/links${InactiveFolioPaths.SEARCH}` && (
                        <div
                            style={{
                                color: 'white',
                            }}
                        >
                            <p
                                style={{
                                    fontSize: '15px',
                                    border: '1px solid black',
                                    padding: 8,
                                    backgroundColor: '#836fe0',
                                    color: 'white',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontFamily: 'Montserrat-SemiBold',
                                }}
                                onClick={() => {
                                    history.push('/links/inactive-folios-track', {
                                        ...props.location.state,
                                        summaryData: null,
                                    });
                                }}
                            >
                                {' '}
                                Track Request{' '}
                            </p>
                        </div>
                    )}
                </div>
            </header>
            <div className={`db-content ${findPath(pathname) ? `mobile-db-content` : ``}`}>
                <main
                    className={`db-content-right full-width`}
                    id="db-content-right"
                    tabIndex={0}
                    aria-label={getPageHeading(pathname) || 'Main content'}
                >
                    <div className="maxWidth">
                        <RouteWrapper
                            routes={QuickLinks}
                            initPath={`/update-pan`}
                            matchPath={path}
                        />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default QuickLinkRoutes;
